<template lang="pug">
.send-message-target-type
  //- error message
  .register-row(v-if="errorMessage != ''")
    .register-group
      span.error-message {{ errorMessage }}
  .register-row
    .register-group
      .register-key
        span.key-name 宛先種別
        span.validation-label 必須
      .register-value
        label.register-radio-label(v-if="enableUseSendTargetToAllWaiter")
          input#type-0.register-radio-form(v-model="innerValue" name="type" type="radio" :value="_sendMessageType.ALL_WAITER" v-validate="{ required: true }" data-vv-as="宛先種別")
          span.register-radio-text 入所申込者全員
        label.register-radio-label(v-if="enableUseSendTargetToWaiter")
          input#type-1.register-radio-form(v-model="innerValue" name="type" type="radio" :value="_sendMessageType.SELECTED_WAITER")
          span.register-radio-text 入所申込者個別
      .error-messages(v-if="errors.has('type')")
        div(v-for="error in errors.collect('type')")
          label.error-message {{ error }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { SendMessageType } from "@/commons/services/SendMessages";

@Component({
  inject: ["$validator"]
})
export default class SendMessageTargetType extends Vue {
  @Prop({ required: true }) value!: SendMessageType | "";
  @Prop({ required: true }) errorMessage!: string;
  @Prop({ required: true }) enableUseSendTargetToAllWaiter!: boolean;
  @Prop({ required: true }) enableUseSendTargetToWaiter!: boolean;

  get _sendMessageType(): typeof SendMessageType {
    return SendMessageType;
  }

  get innerValue(): SendMessageType | "" {
    return this.value;
  }

  set innerValue(val: SendMessageType | "") {
    this.$emit("input", val);
  }
}
</script>
